<template>
	<page>
		<v-row align="center" justify="center">
			<v-col>
				<v-card>
					<v-card-subtitle class="text-center display">פרופיל משתמש</v-card-subtitle>
					<v-row align="center" justify="center" class="pa-10">
						<v-col cols="4">
							<message-box v-if="force" class="text-center" type="error" message="פג תוקף סיסמה, עליך לחדש סיסמה."></message-box>
							<v-card elevation="0">
								<v-card-subtitle> שינוי סיסמה </v-card-subtitle>
								<v-card-text
									v-if="errors && errors.length > 0"
									class="bordered text-center"
								>
									<p
										v-for="(error, index) in errors[0]"
										:key="error + index"
										class="text-center mx-auto"
									>
										{{ error[0] }}
									</p>
								</v-card-text>
								<v-card-text class="text-center">
									<form @submit.prevent="submit">
										<smart-input
											v-model="form.current_password"
											type="password"
											label="סיסמה נוכחית"
											autocomplete="new-password"
										/>
										<smart-input
											v-model="form.password"
											type="password"
											label="סיסמה חדשה"
											autocomplete="new-password"
										/>

										<smart-input
											v-model="form.password_confirmation"
											type="password"
											label="אימות סיסמה"
											autocomplete="new-password"
										/>
										<div class="mt-4">
											<v-btn color="black" type="submit">שנה סיסמה</v-btn>
										</div>
									</form>
								</v-card-text>
							</v-card>
						</v-col>
					</v-row>
				</v-card>
			</v-col>
		</v-row>
	</page>
</template>

<script>
import { types as userTypes } from "src/store/modules/User.module";
import LaravelErrors from "../../helpers/LaravelErrors";
import afterLogin from "../../hooks/AfterLogin";
export default {
	props:{
		force:{type:Boolean,default:false}
	},
	data() {
		return {
			form: {},
			errors: [],
		};
	},
	computed:{
		project() {
			return this.$store.state.ProjectModule.project;
		},
		user() {
			return this.$store.getters.auth;
		}
	},
	methods: {
		async submit() {
			try{
				const res = await this.$store.dispatch(userTypes.CHANGE, this.form);
				if (res.success) {
					this.$notfication.success();
					this.form = {};
					if (this.force){
						afterLogin(this.user,this.project);
					}
				} else {
					this.errors.push(res);
				}
			}
			catch (errors){
				if (errors.response?.data?.errors){
					this.$notfication.error(LaravelErrors.getOneErrorTextOnly(errors.response.data.errors));
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.bordered{
        border: red 1px solid;
        text-align: center;
    }
</style>
